import EA from '../helpers/init';

export default EA.Methods.formHandler = ($this) => {
    const form = $this;

    const validators = {
        nameAndSurname: {
            validate: (val) => val.trim().length >= 2,
            message: 'Please enter your full name.'
        },
        email: {
            validate: (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim()),
            message: 'Please enter a valid email address.'
        },
    };

    function validateField(input) {
        const name = input.name;
        const rule = validators[name];
        if (!rule) return true;

        const errorEl = input.parentNode.querySelector('.error-message');
        const isValid = rule.validate(input.value);

        input.parentNode.classList.toggle('has-error', !isValid);
        if (errorEl) errorEl.textContent = isValid ? '' : rule.message;

        return isValid;
    }

    // Change the display text to file name when a file is selected
    form.querySelectorAll('input[type="file"]').forEach(input => {
        input.addEventListener('change', () => {
            const display = input.parentNode.querySelector('.file-input-display');
            if (!display) return;

            if (input.files.length > 0) {
                display.textContent = input.files[0].name;
                display.classList.add('has-file');
            } else {
                display.textContent = input.name.toUpperCase(); // fallback to "CV"
                display.classList.remove('has-file');
            }
        });
    });

    // Clear error on input
    form.querySelectorAll('input, textarea').forEach(input => {
        input.addEventListener('input', () => validateField(input));

    });

    // Validate all on submit
    form.addEventListener('submit', (e) => {
        e.preventDefault();

        const inputs = form.querySelectorAll('input, textarea');
        let isFormValid = true;

        inputs.forEach(input => {
            if (!validateField(input)) isFormValid = false;
        });

        if (!isFormValid) {
            // Focus the first invalid field
            form.querySelector('.has-error input, .has-error textarea')?.focus();
            return;
        }

        // Submit form
        form.submit();
    });
};
